import { useState } from 'react';

export function useDrawers() {
  const [state, setState] = useState({
    drawerVisible: false,
    formIsActive: false,
    activeRecord: null,
  });

  const openDrawer = (record) => {
    setState({
      ...state,
      activeRecord: record,
      drawerVisible: true,
    });
  };

  const closeDrawer = () => {
    setState({
      ...state,
      activeRecord: null,
      drawerVisible: false,
    });
  };

  const hideDrawer = () => {
    setState({
      ...state,
      drawerVisible: false,
    });
  };

  const openEditForm = () => {
    setState({
      ...state,
      drawerVisible: false,
      formIsActive: true,
    });
  };

  const openCreateForm = () => {
    setState({
      ...state,
      formIsActive: true,
    });
  };

  const closeForm = () => {
    setState({
      ...state,
      formIsActive: false,
      activeRecord: null,
    });
  };

  const returnCreateForm = () => {
    setState({
      formIsActive: true,
      activeRecord: null,
      drawerVisible: false,
    });
  };

  const returnDrawer = (record) => {
    setState({
      activeRecord: record,
      drawerVisible: true,
      formIsActive: false,
    });
  };

  return {
    state,
    openDrawer,
    closeDrawer,
    openEditForm,
    openCreateForm,
    closeForm,
    hideDrawer,
    returnCreateForm,
    returnDrawer,
  };
}
